import { createSlice } from '@reduxjs/toolkit';
import { getActiveCoupons, validateCoupon } from '../apis/CouponApi';

const initialState = {
  coupons: [],
  appliedCoupon: null,
  loading: false,
  error: null,
  success: null
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = null;
    },
    removeCoupon: (state) => {
      state.appliedCoupon = null;
      state.success = null;
    }
  },
  extraReducers: (builder) => {
    // Get Active Coupons
    builder
      .addCase(getActiveCoupons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActiveCoupons.fulfilled, (state, action) => {
        state.loading = false;
        // Handle both {data:[]} and {data:{coupons:[]}} shapes
        const payload = action.payload;
        const raw = payload?.data;
        state.coupons = Array.isArray(raw) ? raw
          : Array.isArray(raw?.coupons) ? raw.coupons
          : [];
      })
      .addCase(getActiveCoupons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch coupons';
      });

    // Validate Coupon
    builder
      .addCase(validateCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateCoupon.fulfilled, (state, action) => {
        state.loading = false;
        // API: {success, message, data:{coupon, discount, finalAmount}}
        state.appliedCoupon = action.payload?.data || action.payload?.coupon || action.payload;
        state.success = action.payload.message;
      })
      .addCase(validateCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to validate coupon';
        state.appliedCoupon = null;
      });
  }
});

export const { clearError, clearSuccess, removeCoupon } = couponSlice.actions;
export default couponSlice.reducer;
